import { IList } from 'annotation-tools/utils';
import { ILabelSummary } from '../../../types/record/label-summary';
import {
  IProjectSummary,
  IProjectSummaryType
} from '../../../types/record/project-summary';
import { ProjectSummaryAPIRawSuccessResponseType } from '../../types/project-summary/api-response';
import { IModelFromAPISuccessResponse } from '../model/from-api-repsonse';

export const IProjectSummaryFromAPISuccessResponse = (
  list: ProjectSummaryAPIRawSuccessResponseType[]
): IList<IProjectSummaryType> =>
  IList<IProjectSummaryType>(
    list.map((e: ProjectSummaryAPIRawSuccessResponseType) =>
      IProjectSummary({
        model: IModelFromAPISuccessResponse(e.model),
        labels: IList(e.labels.map(ILabelSummary))
      })
    )
  );
